import { useCallback, useEffect, useRef } from "react";
import { useXarrow } from "react-xarrows";

const useThrottledXarrow = () => {
    const rawUpdate = useXarrow();
    const fnRef = useRef(rawUpdate);
    const rafRef = useRef<number | null>(null);

    useEffect(() => {
        fnRef.current = rawUpdate;
    }, [rawUpdate]);

    const schedule = useCallback(() => {
        if (rafRef.current != null) return;
        rafRef.current = requestAnimationFrame(() => {
            rafRef.current = null;
            fnRef.current();
        });
    }, []);

    useEffect(
        () => () => {
            if (rafRef.current != null) cancelAnimationFrame(rafRef.current);
        },
        []
    );

    return schedule; // stable identity
};

export default useThrottledXarrow;
